export default "__VITE_ASSET__DAIHQZ5b__"